import type { AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

const env = import.meta.env;

export const cognitoDomain = env.VITE_COGNITO_DOMAIN as string;
export const clientId = env.VITE_COGNITO_CLIENT_ID as string;
export const redirectUri = env.VITE_REDIRECT_URI as string;
export const logoutUri = env.VITE_LOGOUT_URI as string;

export const oidcConfig: AuthProviderProps = {
  authority: env.VITE_COGNITO_AUTHORITY as string,
  client_id: clientId,
  redirect_uri: redirectUri,
  response_type: "code",
  scope: "openid email profile",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, "/");
  },
};

export function isAdmin(profile: Record<string, unknown> | undefined): boolean {
  const groups = profile?.["cognito:groups"];
  if (Array.isArray(groups)) return groups.includes("admin");
  if (typeof groups === "string") return groups.split(/[\s,]+/).includes("admin");
  return false;
}

export function buildLogoutUrl(): string {
  // Cognito-hosted logout endpoint.
  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: logoutUri,
  });
  return `https://${cognitoDomain}/logout?${params.toString()}`;
}
